// Candidate only. Integrate at both initial and change request sites in reviewed theme source.
export function canonicalForm(serialized) {
  // URLSearchParams is iterable, but this theme's loose Babel spread transform
  // assumes arrays. Iterate explicitly so compiled and source behavior agree.
  const rows = [];
  new URLSearchParams(serialized).forEach((value, name) => {
    if (name === 'product_id' || name.startsWith('attribute[')) rows.push([name, value]);
  });
  return JSON.stringify(rows.sort(([an], [bn]) => an < bn ? -1 : an > bn ? 1 : 0));
}
const formGates = new WeakMap();
export function guardPilotResponse(form, readForm, serialized, apply, onError) {
  const ids = new URLSearchParams(serialized).getAll('product_id');
  if (ids.length !== 1 || ids[0] !== '113426') return apply;
  const gate = gateForForm(form, readForm);
  return gate.guard(gate.issue(serialized), apply, onError);
}
export function gateForForm(form, readForm) {
  let gate = formGates.get(form);
  if (!gate || gate.disposed) {
    gate = new LatestOptionRequest(readForm, () => form.isConnected);
    formGates.set(form, gate);
  }
  return gate;
}
export class LatestOptionRequest {
  constructor(readForm, isConnected = () => true) {
    this.readForm = readForm; this.isConnected = isConnected;
    this.sequence = 0; this.disposed = false;
  }
  issue(serialized = this.readForm()) {
    return {sequence: ++this.sequence, fingerprint: canonicalForm(serialized)};
  }
  current(ticket) {
    return !this.disposed && this.isConnected() && ticket.sequence === this.sequence &&
      ticket.fingerprint === canonicalForm(this.readForm());
  }
  guard(ticket, apply, onError = () => {}) {
    const owner = this;
    return function(error, response) {
      if (!owner.current(ticket)) return;
      if (error || !response || typeof response.data !== 'object' || response.data === null || Array.isArray(response.data)) {
        onError.call(this, error, response); return;
      }
      return apply.call(this, error, response);
    };
  }
  dispose() { this.disposed = true; ++this.sequence; }
}
